import React from 'react';
import './App.css';
import Layout from './containers/Layout';

import 'semantic-ui-css/semantic.min.css';

function App() {
	return (
		<div
			className="App"
			style={{ backgroundColor: ' #f9f7e8', fontFamily: 'Quicksand' }}
		>
			<Layout />
		</div>
	);
}

export default App;
